import { Global } from "@mantine/core";

export default function GlobalStyles() {
  return (
    <Global
      styles={(theme) => ({
        "*, *::before, *::after": {
          padding: 0,
          margin: 0,
          boxSizing: "border-box",
        },
      })}
    />
  );
}
